import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px 20px;
  background: ${(props) => props.theme.colors?.white || '#FFFFFF'};
  border: 1px solid ${(props) => props.theme.colors?.border || '#E5E7EB'};
  border-radius: 12px;
  transition: all 0.2s ease;
  gap: 12px;

  ${(props) =>
    props.$selected &&
    css`
      border-color: ${props.theme.colors?.primary || '#3B82F6'};
      background: ${props.theme.colors?.primaryLight || '#EFF6FF'};
    `}

  &:hover {
    border-color: ${(props) => props.theme.colors?.primaryHover || '#93C5FD'};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const CheckboxWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-top: 2px;
`;

export const IconCircle = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.$bgColor || 'linear-gradient(135deg, #A78BFA 0%, #8B5CF6 100%)'};
  color: ${(props) => props.$iconColor || '#FFFFFF'};
`;

export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const TitleArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
`;

export const Title = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || '#111827'};
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${(props) => props.$bgColor || '#E5E7EB'};
  color: ${(props) => props.$color || '#374151'};
`;

export const RightArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const UnreadDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors?.primary || '#3B82F6'};
`;

export const Timestamp = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
  white-space: nowrap;
`;

export const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  color: ${(props) => props.theme.colors?.textSecondary || '#9CA3AF'};

  &:hover {
    background: ${(props) => props.theme.colors?.backgroundHover || '#F3F4F6'};
    color: ${(props) => props.theme.colors?.text || '#374151'};
  }
`;

export const AISummaryRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  background: ${(props) => props.theme.colors?.backgroundLight || '#F9FAFB'};
  border-radius: 8px;
`;

export const AISummaryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: linear-gradient(135deg, #A78BFA 0%, #8B5CF6 100%);
  color: #FFFFFF;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const AISummaryText = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
  line-height: 1.5;
  flex: 1;
`;

export const ExpandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  color: ${(props) => props.theme.colors?.textSecondary || '#9CA3AF'};
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: ${(props) => (props.$expanded ? 'rotate(180deg)' : 'rotate(0deg)')};

  &:hover {
    color: ${(props) => props.theme.colors?.text || '#374151'};
  }
`;

export const QuoteSection = styled.div`
  display: ${(props) => (props.$visible ? 'flex' : 'none')};
  align-items: flex-start;
  gap: 10px;
  padding-left: 12px;
  border-left: 3px solid ${(props) => props.theme.colors?.primary || '#3B82F6'};
  margin-left: 4px;
`;

export const QuoteAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors?.backgroundSecondary || '#E5E7EB'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const QuoteContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const QuoteAuthor = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || '#111827'};
  margin-bottom: 2px;
`;

export const QuoteText = styled.div`
  font-size: 13px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
  line-height: 1.4;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const AgentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const AgentAvatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors?.backgroundSecondary || '#E5E7EB'};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AgentName = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;

export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  color: ${(props) => props.theme.colors?.textTertiary || '#9CA3AF'};
`;

export const Separator = styled.span`
  color: ${(props) => props.theme.colors?.textTertiary || '#D1D5DB'};
  font-size: 10px;
`;

export const LiveBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: #DCFCE7;
  color: #16A34A;
`;

export const MoreBadge = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors?.primary || '#3B82F6'};
  font-weight: 500;
`;
